module.exports = __webpack_public_path__ + "img/03.7d3b2ca5.jpg";